module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head2"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAPS")])])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "map1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/map.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 1. Justinian’s empire, ca. 565.")])]), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "map2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/map2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 2. The Byzantine empire, ca. 1025.")])]), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "map3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/map3.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Map 3. Byzantium, ca. 1350.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31984256","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map.vue
// module id = 87
// module chunks = 0